import styled from 'styled-components';
import { themeGetColor } from 'modules/v2/foundation/theme';
import { StyledTableBodyCell } from '../TableCell/TableBodyCell/styled';
export const TableRow = styled.tr `
  ${StyledTableBodyCell} {
    ${(props) => props.disabled && `opacity: 0.5;`};

    &:first-child {
      border-top-left-radius: var(--table-border-radius);
      border-bottom-left-radius: var(--table-border-radius);
    }

    &:last-child {
      border-top-right-radius: var(--table-border-radius);
      border-bottom-right-radius: var(--table-border-radius);
    }

    // Make the blue highlight color 50% transparent, but solid in order to not have elements bleed trough.
    ${(p) => p.$selected &&
    `background-color: color-mix(in srgb, ${themeGetColor('background.50')} 100%, ${themeGetColor('blue.50')} 50%)`};
  }

  &:not([disabled])&:hover ${StyledTableBodyCell} {
    background-color: ${(p) => (p.$selected ? themeGetColor('blue.50') : themeGetColor('background.75'))};
  }
`;
